<template>
  <div  class="ais-public-search">
    <ais-instant-search
    :search-client="searchClient"
    :index-name="indexName"

    @submit.prevent="alert('test')"
    >
    <ais-search-box >
      <form class="ais-SearchBox-form" novalidate slot-scope="{ currentRefinement, isSearchStalled, refine }">
        <input
        id="ais-search-input"
        type="search"
        class="ais-SearchBox-input" autocomplete="off" autocorrect="off" autocapitalize="off"  spellcheck="false" maxlength="512" placeholder="Search Crystal Council"
        v-model="query"
        @keyup.enter="search"
        @input="refine($event.currentTarget.value)"
        @focus="show_results = true"
        @blur="show_results = false"
        >
        <span :hidden="!isSearchStalled">Loading...</span>
        <button class="ais-SearchBox-submit" type="submit" title="Submit the search query.">
          <i class="fas fa-search"></i>
        </button>
        <span class="ais-SearchBox-loadingIndicator" hidden>
          <svg width="16" height="16" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#444" class="ais-SearchBox-loadingIcon">
            ...
          </svg>
        </span>
      </form>
    </ais-search-box>
    <ais-configure
    :hitsPerPage="4"
    />

    <ais-state-results v-bind:class="[show_results ? 'focused' : 'no-focused']">
      <template slot-scope="{ hits }" v-model="hits">
        <div v-show="query.length > 2">
          <ais-hits v-if="hits.length == 0">
            <ol class="ais-Hits-list">
              <li class="ais-Hits-item">There are no results found for: <q>{{query}}</q></li>
            </ol>
            
          </ais-hits>
          <div v-else>

            <ais-hits>
              <template slot="item" slot-scope="{ item }">
                <a :href="item.link" v-if="item.link" class="text-left">
                  <div class="row" v-if="item.type !== 'Property'">
                    <div class="col-4">
                      <img :src="item.image" />
                    </div>
                    <div class="col-8">
                      <small class="d-block"><i>{{ item.type }}</i></small>
                      <b class="d-block"><ais-highlight :hit="item" attribute="title" /></b>
                      <span v-if="item.cost">${{ item.cost.toFixed(2) }}</span>
                    </div>
                  </div>
                  <div class="row mb-3" v-else>
                    <div class="col-12">
                      <b class="d-block"><ais-highlight :hit="item" attribute="title" /></b>
                    </div>
                  </div>
                </a>
                <a :href="item.link + '/products'" v-if="item.link && item.type == 'Property'" class="text-left">
                  <div class="row" v-if="item.type == 'Property'">
                    <div class="col-12">
                      <b class="d-block">{{ productString(item.title) }}</b>
                    </div>
                  </div>
                </a>
              </template>
            </ais-hits>
            <a :href="searchUrl" class="bg-light">
                <ol class="ais-Hits-list mt-0">
                    <li class="ais-Hits-item font-weight-bold text-primary text-center"><i class="far fa-eye mr-2"></i>View All Results</li>
                </ol>
            </a>
          </div>
        </div>

      </template>
      
    </ais-state-results>
  </ais-instant-search>
</div>

</template>

<script>
import algoliasearch from 'algoliasearch/lite';
var algoliaClient = algoliasearch('4WU7EUB6MA', 'a3ec5002a3957d8af1b14c20fef02073', {protocol: 'https:'});
var index = algoliaClient.initIndex('public_search');

const searchClient = {
  ...algoliaClient,
  search(requests) {
    if (requests.every(({ params }) => params.query.length < 1)) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0,
        })),
      });
    }
    if (requests.every(({ params }) => params.query === "")) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0,
        })),
      });
    }
    return algoliaClient.search(requests);
  },
};


export default {
  data() {
    return {
      searchClient: searchClient,
      indexName: 'dev_public_search',
      query: '',
      show_results: false,
      hits: {}
    };
  },
  mounted() {

  },
  computed: {
    searchUrl: function() {
      return "/search/" + this.query;
    },
  },
  methods: {
    search: function(){
      window.location.href = this.searchUrl;
    },
    productString: function(text){
      return text.replace(' Crystals', ' Products')
    }
  }
};
</script>